import { render, staticRenderFns } from "./UnreadSeparator.vue?vue&type=template&id=1058e88e&"
import script from "./UnreadSeparator.vue?vue&type=script&lang=js&"
export * from "./UnreadSeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports